<template>
    <v-autocomplete
        ref="r_facility"
        v-model="facility"
        clearable
        color="teal"
        label="Name of Hospital/Clinic"
        :items="getReqHospClin"
        item-text="hosp_name"
        :rules="rules.fieldRules"
        return-object
        auto-select-first
        autocomplete="nope"
        :loading="loading.main || loading.req.hospital"
        :disabled="loading.main || loading.req.hospital"
        @click:clear="handleClearReqHospClin"
        @change="handleChangeFilities($event)"
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['req', 'member_model', 'loading'],
    data: ()=>({
        facility: null,
        rules: {
            fieldRules: [v => !!v || 'This field is required!']
        }
    }),
    computed: {
        ...mapGetters(['getReqHospClin'])
    },
    watch: {
        getReqHospClin() {
            this.loading.req.hospital = false
        },
        'req.facility'(newVal) {
            this.facility = newVal
        }
    },
    methods: {
        ...mapActions(['reqProvinces', 'reqCities', 'reqDoctors', 'reqHospClin']),
        handleChangeFilities(value) {
            this.req.facility = value
            if (value) {
                this.req.hospClinDoctor = ''
                this.req.hospClinDoctorCode=null
                this.req.region = String(value.hosp_region).trim()
                this.req.province = String(value.city_province).trim()
                this.req.city = String(value.city_name).trim()
            } else {
                this.req.filter.doc = false
                if (this.req.specField) this.req.specField = { sp_name: 'ALL', sp_desc: '' }
            }
            this.req.hospClinDoctor = ''
            this.req.hospClinDoctorCode = null
            this.loading.req.province = true
            this.reqProvinces({ REGION: this.req.region })
            this.loading.req.region = true
            this.reqCities({ REGION: this.req.region, PROVINCE: this.req.province })
            this.loading.req.doctor = true
            this.reqDoctors({ PTYPE: '', HOSP_MSU: value && value.hosp_msu_code, SPEC: this.req.specField && this.req.specField.sp_desc })
            if (this.req.filter.hosp) {
                this.loading.req.hospital = true
                this.reqHospClin({ REGION: this.req.region, PROVINCE: this.req.province, CITY: this.req.city, TYPE: '', MEMBN: this.member_model.MEMB_N })
            }
            this.req.hospClinType = value && value.hosp_ptype
            this.req.decking = value && value.hosp_decking
        },
        handleClearReqHospClin() {
            this.req.region = ''
            this.req.province = ''
            this.req.city = ''
        }
    }
}
</script>
